module.exports = __webpack_public_path__ + "img/mobile-view-el.3ec04dc.png";